export interface Product {
  id: number;
  title: string;
  category: string;
  description: string;
  image: string;
  features: string[];
  accent: string;
  bg: string;
  textColor: string;
}

const products: Product[] = [
  // =========================
  // TABLES
  // =========================
  {
    id: 1,
    title: "Coffee Table",
    category: "Tables",
    description:
      "Elegant coffee table crafted with premium materials, combining modern aesthetics with everyday functionality for contemporary living spaces.",
    image:
      "/product/coffee-table.webp",
    features: [
      "Premium Finish",
      "Modern Design",
      "Durable Construction",
      "Easy Maintenance",
    ],
    accent: "#B88A44",
    bg: "#F8F6F3",
    textColor: "#111827",
  },
  {
    id: 2,
    title: "Dining Table",
    category: "Tables",
    description:
      "Beautifully designed dining table that offers timeless elegance and lasting durability for family gatherings.",
    image:
      "/product/dining-table.webp",
    features: [
      "Solid Construction",
      "Premium Finish",
      "Elegant Design",
      "Spacious Surface",
    ],
    accent: "#8C6239",
    bg: "#FAF6F1",
    textColor: "#111827",
  },
  {
    id: 3,
    title: "Console Table",
    category: "Tables",
    description:
      "Sophisticated console table perfect for hallways, entrances, and living rooms with luxurious craftsmanship.",
    image:
      "/product/console-table.webp",
    features: [
      "Slim Profile",
      "Luxury Finish",
      "Decorative Appeal",
      "Premium Quality",
    ],
    accent: "#A9745A",
    bg: "#F9F4F2",
    textColor: "#111827",
  },
  {
    id: 4,
    title: "Side Table",
    category: "Tables",
    description:
      "Compact side table offering functionality and elegance beside sofas, beds, and lounge chairs.",
    image:
      "/product/side-table.webp",
    features: [
      "Compact Size",
      "Modern Look",
      "Durable Finish",
      "Multipurpose",
    ],
    accent: "#B8865B",
    bg: "#FDF8F4",
    textColor: "#111827",
  },
  {
    id: 5,
    title: "Center Table",
    category: "Tables",
    description:
      "Premium center table designed to become the focal point of luxury living spaces.",
    image:
      "/product/center-table.webp",
    features: [
      "Premium Craftsmanship",
      "Luxury Finish",
      "Elegant Style",
      "Long Lasting",
    ],
    accent: "#C49A6C",
    bg: "#FBF8F3",
    textColor: "#111827",
  },

  // =========================
  // HOME DECOR
  // =========================
  {
    id: 6,
    title: "Candle Holders",
    category: "Home Décor",
    description:
      "Decorative candle holders designed to enhance interiors with warmth and elegance.",
    image:
      "/product/candle-holder.webp",
    features: [
      "Decorative Finish",
      "Premium Metal",
      "Elegant Design",
      "Handcrafted",
    ],
    accent: "#C9A227",
    bg: "#FFF9EE",
    textColor: "#111827",
  },
  {
    id: 7,
    title: "Decorative Vases",
    category: "Home Décor",
    description:
      "Luxury decorative vases that complement modern and classic interior spaces.",
    image:
      "/product/decorative-vases.webp",
    features: [
      "Artisan Crafted",
      "Premium Finish",
      "Contemporary Design",
      "Luxury Décor",
    ],
    accent: "#8E7AB5",
    bg: "#F8F6FC",
    textColor: "#111827",
  },
  {
    id: 8,
    title: "Wall Décor",
    category: "Home Décor",
    description:
      "Designer wall décor pieces created to transform interiors with artistic appeal.",
    image:
      "/product/wall-decor.webp",
    features: [
      "Modern Art",
      "Premium Finish",
      "Easy Installation",
      "Elegant Design",
    ],
    accent: "#7D5A50",
    bg: "#FAF5F3",
    textColor: "#111827",
  },
  {
    id: 9,
    title: "Tabletop Sculptures",
    category: "Home Décor",
    description:
      "Unique tabletop sculptures adding sophistication and artistic beauty to every setting.",
    image:
      "/product/tabletop.webp",
    features: [
      "Luxury Finish",
      "Handcrafted",
      "Premium Material",
      "Modern Design",
    ],
    accent: "#B57A5A",
    bg: "#FDF8F5",
    textColor: "#111827",
  },
  {
    id: 10,
    title: "Decorative Trays",
    category: "Home Décor",
    description:
      "Premium decorative trays blending functionality with timeless luxury styling.",
    image:
      "/product/trays.webp",
    features: [
      "Premium Finish",
      "Luxury Design",
      "Easy Maintenance",
      "Versatile Use",
    ],
    accent: "#C08B5C",
    bg: "#FFF8F1",
    textColor: "#111827",
  },

  // =========================
  // GARDEN DECOR
  // =========================
  {
    id: 11,
    title: "Garden Planters",
    category: "Garden Décor",
    description:
      "Stylish outdoor planters crafted to enhance gardens, patios, and landscapes.",
    image:
      "/product/garden-plantner.webp",
    features: [
      "Weather Resistant",
      "Outdoor Use",
      "Premium Finish",
      "Long Lasting",
    ],
    accent: "#4E7D4A",
    bg: "#F3F9F2",
    textColor: "#111827",
  },
  {
    id: 12,
    title: "Garden Fountains",
    category: "Garden Décor",
    description:
      "Elegant fountains designed to create peaceful and luxurious outdoor environments.",
    image:
      "/product/fountain.webp",
    features: [
      "Weatherproof",
      "Elegant Design",
      "Outdoor Ready",
      "Premium Quality",
    ],
    accent: "#2C7FB8",
    bg: "#EFF8FD",
    textColor: "#111827",
  },
  {
    id: 13,
    title: "Bird Baths",
    category: "Garden Décor",
    description:
      "Decorative bird baths crafted to add charm and attract wildlife to gardens.",
    image:
      "/product/bird-bath.webp",
    features: [
      "Outdoor Safe",
      "Elegant Design",
      "Weather Resistant",
      "Premium Finish",
    ],
    accent: "#6AA6A6",
    bg: "#F2FBFB",
    textColor: "#111827",
  },
  {
    id: 14,
    title: "Outdoor Lanterns",
    category: "Garden Décor",
    description:
      "Luxury outdoor lanterns providing beautiful lighting and decorative appeal.",
    image:
      "/product/outdoor-lanterns.webp",
    features: [
      "Weatherproof",
      "Premium Finish",
      "Outdoor Lighting",
      "Rust Resistant",
    ],
    accent: "#D39B38",
    bg: "#FFF9EC",
    textColor: "#111827",
  },
  {
    id: 15,
    title: "Garden Sculptures",
    category: "Garden Décor",
    description:
      "Premium artistic sculptures designed for luxurious landscape decoration.",
    image:
      "/product/garden-scupture.webp",
    features: [
      "Artisan Crafted",
      "Outdoor Safe",
      "Weather Resistant",
      "Luxury Design",
    ],
    accent: "#8A6A4A",
    bg: "#F8F6F2",
    textColor: "#111827",
  },

  // =========================
  // KITCHEN GEAR
  // =========================
  {
    id: 16,
    title: "Cookware",
    category: "Kitchen Gear",
    description:
      "Premium cookware collection designed for modern kitchens and professional performance.",
    image:
      "/product/coockware.webp",
    features: ["Food Safe", "Durable", "Premium Finish", "Easy Cleaning"],
    accent: "#A94442",
    bg: "#FFF5F5",
    textColor: "#111827",
  },
  {
    id: 17,
    title: "Serveware",
    category: "Kitchen Gear",
    description:
      "Elegant serveware collection for stylish dining and entertaining.",
    image:
      "/product/serveware.webp",
    features: [
      "Premium Finish",
      "Elegant Design",
      "Food Safe",
      "Luxury Style",
    ],
    accent: "#A76D60",
    bg: "#FCF5F4",
    textColor: "#111827",
  },
  {
    id: 18,
    title: "Kitchen Utensils",
    category: "Kitchen Gear",
    description:
      "High-quality kitchen utensils built for comfort, durability, and efficiency.",
    image:
      "/product/kitchen-utensil.webp",
    features: [
      "Ergonomic Design",
      "Food Grade",
      "Rust Resistant",
      "Long Lasting",
    ],
    accent: "#5B8C5A",
    bg: "#F3FAF3",
    textColor: "#111827",
  },
  {
    id: 19,
    title: "Storage Canisters",
    category: "Kitchen Gear",
    description:
      "Premium storage canisters that combine practicality with elegant kitchen décor.",
    image:
      "/product/storage-canister.webp",
    features: [
      "Airtight",
      "Premium Material",
      "Modern Design",
      "Easy Storage",
    ],
    accent: "#3E7CB1",
    bg: "#F3F8FC",
    textColor: "#111827",
  },
  {
    id: 20,
    title: "Cutlery & Flatware",
    category: "Kitchen Gear",
    description:
      "Luxury cutlery collection crafted for elegant dining experiences.",
    image:
      "/product/cutlery.webp",
    features: [
      "Premium Stainless Steel",
      "Elegant Finish",
      "Food Safe",
      "Rust Resistant",
    ],
    accent: "#7A7A7A",
    bg: "#F8F8F8",
    textColor: "#111827",
  },

  // =========================
  // BATHROOM
  // =========================
  {
    id: 21,
    title: "Bathroom Accessories Set",
    category: "Bathroom",
    description:
      "Luxury bathroom accessory set designed for organized and elegant interiors.",
    image:
      "/product/batthroom-set.webp",
    features: [
      "Premium Finish",
      "Elegant Design",
      "Easy Cleaning",
      "Complete Set",
    ],
    accent: "#6F9FC5",
    bg: "#F2F8FC",
    textColor: "#111827",
  },
  {
    id: 22,
    title: "Soap Dispensers & Soap Dishes",
    category: "Bathroom",
    description:
      "Stylish soap dispensers and dishes that elevate modern bathroom décor.",
    image:
      "/product/dispanser.webp",
    features: [
      "Premium Finish",
      "Modern Design",
      "Easy Refill",
      "Durable Material",
    ],
    accent: "#6CA6CD",
    bg: "#F5FAFD",
    textColor: "#111827",
  },
  {
    id: 23,
    title: "Towel Racks & Towel Rings",
    category: "Bathroom",
    description:
      "Premium towel holders offering elegant organization for contemporary bathrooms.",
    image:
      "/product/towel.webp",
    features: [
      "Rust Resistant",
      "Premium Finish",
      "Easy Installation",
      "Long Lasting",
    ],
    accent: "#7D91B3",
    bg: "#F4F7FB",
    textColor: "#111827",
  },
  {
    id: 24,
    title: "Toilet Paper Holders",
    category: "Bathroom",
    description:
      "Elegant toilet paper holders crafted with durability and modern styling.",
    image:
      "/product/toilet-paper.webp",
    features: [
      "Rust Resistant",
      "Premium Material",
      "Modern Look",
      "Easy Installation",
    ],
    accent: "#8A9BB1",
    bg: "#F7F9FB",
    textColor: "#111827",
  },
  {
    id: 25,
    title: "Bathroom Shelves & Organizers",
    category: "Bathroom",
    description:
      "Smart bathroom storage solutions that maximize space while maintaining luxury aesthetics.",
    image:
      "/product/bathroom-shelf.webp",
    features: [
      "Space Saving",
      "Premium Finish",
      "Easy Installation",
      "Moisture Resistant",
    ],
    accent: "#4F81BD",
    bg: "#EFF6FC",
    textColor: "#111827",
  },
];

export default products;